"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports.Shimmer = exports.FlexRow = exports.FlexColumn = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  background: #f6f7f8;\n  background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);\n  background-repeat: no-repeat;\n  display: inline-block;\n  position: relative; \n\n  -webkit-background-size: 60rem 100%;\n  -moz-background-size: 60rem 100%;\n  background-size: 60rem 100%;\n\n  -webkit-animation-duration: 2s;\n  -webkit-animation-fill-mode: forwards; \n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-name: ", ";\n  -webkit-animation-timing-function: ease-out;\n  \n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    background-position: -100rem 0;\n  }\n  \n  100% {\n    background-position: 120rem 0; \n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n\n  font-size: ", ";\n  font-weight: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var Container = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.display && "display: " + props.display + ";";
}, function (props) {
  return props.content && "content: " + props.content + ";";
}, function (props) {
  return props.flex && "flex: " + props.flex + ";";
}, function (props) {
  return props.flexDirection && "display: flex; flex-direction: " + props.flexDirection + ";";
}, function (props) {
  return props.hidden && "display: none !important;";
}, function (props) {
  return props.height && "height: " + props.height + ";";
}, function (props) {
  return props.width && "width: " + props.width + ";";
}, function (props) {
  return props.margin && "margin: " + props.margin + ";";
}, function (props) {
  return props.padding && "padding: " + props.padding + ";";
}, function (props) {
  return props.justifyContent && "justify-content: " + props.justifyContent + ";";
}, function (props) {
  return props.alignItems && "align-items: " + props.alignItems + ";";
}, function (props) {
  return props.alignSelf && "align-self: " + props.alignSelf + ";";
}, function (props) {
  return props.textAlign && "text-align: " + props.textAlign + ";";
}, function (props) {
  return props.overflow && "overflow: " + props.overflow + ";";
}, function (props) {
  return props.position && "position: " + props.position + ";";
}, function (props) {
  return props.backgroundColor && "background-color: " + props.backgroundColor + ";";
}, function (props) {
  return props.boxSizing && "box-sizing: " + props.boxSizing + ";";
}, function (props) {
  return props.zIndex && "z-index: " + props.zIndex + ";";
}, function (props) {
  return props.cursor && "cursor: " + props.cursor + ";";
}, function (props) {
  return props.opacity && "opacity: " + props.opacity + ";";
}, function (props) {
  return props.top && "top: " + props.top + ";";
}, function (props) {
  return props.bottom && "bottom: " + props.bottom + ";";
}, function (props) {
  return props.left && "left: " + props.left + ";";
}, function (props) {
  return props.right && "right: " + props.right + ";";
}, function (props) {
  return props.fontSize ? props.fontSize : "1.2rem";
}, function (props) {
  return props.fontWeight ? props.fontWeight : "400";
});

exports.Container = Container;
var FlexColumn = (0, _styledComponents["default"])(Container)(_templateObject2());
exports.FlexColumn = FlexColumn;
var FlexRow = (0, _styledComponents["default"])(Container)(_templateObject3());
exports.FlexRow = FlexRow;
var placeholderShimmer = (0, _styledComponents.keyframes)(_templateObject4());
var Shimmer = (0, _styledComponents["default"])(Container)(_templateObject5(), placeholderShimmer);
exports.Shimmer = Shimmer;